import { IHateoasLink } from '@store'

export const selectLink = (
  links: ReadonlyArray<IHateoasLink>,
  rel: string,
): IHateoasLink | undefined => links.find((link: IHateoasLink) => link.rel === rel)
